import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom"
// import "./assets/css/main.css"
import { api_call, empty } from '../helpers/untils';
import { HOME_VIDEO_ID } from '../config/constant';
import 'react-modal-video/scss/modal-video.scss';
import ModalVideo from 'react-modal-video';

const FrontSiteNavbar = (props) => {
    const { setShoppingCartLink, setAppSetting, linkOuter = false } = props

    const history = useHistory()

    const [isOpen, setOpen] = useState(false)
    const [youtubeId, setYoutubeId] = useState("")
    const [priceLink, setPriceLink] = useState("")

    useEffect(() => {
        getAppSetting();
    }, []);

    const getAppSetting = async () => {
        const response = await api_call(`/api/get-app-setting`);
        if (response.ok) {
            const app_setting = await response.json()
            setYoutubeId(app_setting['YOUTUBE_VIDEO_ID'])
            setPriceLink(app_setting['SHOPPING_CART_LINK'])
            if (setShoppingCartLink) {
                setShoppingCartLink(app_setting['SHOPPING_CART_LINK'])
            }
            if (setAppSetting) {
                setAppSetting(app_setting)
            }
        }
    }

    return (
        <React.Fragment>
            <header id="header" className="navbar navbar-expand-lg navbar-end navbar-absolute-top navbar-light navbar-show-hide"
                data-hs-header-options='{
    "fixMoment": 300,
    "fixEffect": "slide"
  }'>
                <div className="container">
                    <nav className="js-mega-menu navbar-nav-wrap">
                        <Link className="navbar-brand cursor-pointer" target={linkOuter ? "_blank" : "_self"} to="/" aria-label="LandingPage">
                            <img className="navbar-brand-logo" src="/assets/img/logo.png" alt="Logo" />
                        </Link>
                        <button className="navbar-toggler custom-navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-default">
                                <i className="bi-list"></i>
                            </span>
                            <span className="navbar-toggler-toggled">
                                <i className="bi-x"></i>
                            </span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNavDropdown">
                            <div className="navbar-absolute-top-scroller">
                                <ul className="navbar-nav">
                                    <li className="nav-item mb-1 mt-1">
                                        <Link id="loginMenu" className="btn btn-primary" target={linkOuter ? "_blank" : "_self"} to="/login">Login</Link>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <Link id="contactMenu" className="btn btn-primary" target={linkOuter ? "_blank" : "_self"} to="/contact">Contact</Link>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <Link id="pricingMenu" className="btn btn-primary" target={linkOuter ? "_blank" : "_self"} to="/pricing">Pricing</Link>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <Link id="shopIntroMenu" className="btn btn-primary" target={linkOuter ? "_blank" : "_self"} to="/shop-intro">Shop</Link>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <a id="contactMenu" className="btn btn-primary " aria-current="page" onClick={() => setOpen(true)} role="button" aria-expanded="false">Video</a>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <Link className="btn btn-primary " to="/find-installer" target="_blank">Installers</Link>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <a className="btn btn-primary " href="/faq" target={linkOuter ? "_blank" : "_self"}>FAQ</a>
                                    </li>
                                    <li className="nav-item mb-1 mt-1">
                                        <Link className="nav-link" to="/documentation" target={linkOuter ? "_blank" : "_self"}>&nbsp;API&nbsp;</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
                <React.Fragment>
                    {
                        (isOpen) ? (
                            <>
                                <ModalVideo
                                    channel='youtube'
                                    autoplay={1}
                                    youtube={{
                                        autoplay: 1,
                                        mute: 1
                                    }}
                                    isOpen={isOpen}
                                    videoId={HOME_VIDEO_ID}
                                    onClose={() => setOpen(false)}
                                />
                            </>
                        ) : (<></>)
                    }

                </React.Fragment>
            </header>
        </React.Fragment>
    );
};

export default FrontSiteNavbar;
